// @flow
import SyncTargetsContainer from './containers/SyncTargetsContainer';

export default SyncTargetsContainer;